import {Tooltip} from 'platform/components';
import {Icon, Show} from 'platform/foundation';

import i18n from '@dms/i18n';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {isInvalidEmail} from '../../utils/isInvalidEmail';

type InvalidEmailWarningProps = {
  email: string | Nullish;
} & TestIdProps;

/** A warning icon for a stored e-mail that the DMS API refuses; nothing for other e-mails. */
export function InvalidEmailWarning(props: InvalidEmailWarningProps) {
  return (
    <Show when={isInvalidEmail(props.email)}>
      <Tooltip label={i18n.t('general.validations.invalidEmail')}>
        <Icon
          value="alert/warning"
          size={3}
          color="text.warning"
          data-testid={suffixTestId('invalidEmailWarning', props)}
        />
      </Tooltip>
    </Show>
  );
}
